import { useMemo } from "react";

const makeStars = (count) =>
  Array.from({ length: count }, (_, i) => ({
    id: `star-${i}`,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2.5 + 1,
    dur: Math.random() * 3 + 2.2,
    delay: Math.random() * 4,
  }));

const makeParticles = (count) =>
  Array.from({ length: count }, (_, i) => ({
    id: `particle-${i}`,
    left: Math.random() * 100,
    bottom: Math.random() * 40,
    size: Math.random() * 10 + 6,
    dur: Math.random() * 10 + 10,
    delay: Math.random() * 8,
  }));

export const Background = () => {
  // makeStars/makeParticles are module-scope & stable; run once on mount.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stars = useMemo(() => makeStars(46), []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const particles = useMemo(() => makeParticles(14), []);

  return (
    <div className="starfield" aria-hidden="true">
      {/* soft light mist */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(60% 40% at 50% 0%, rgba(255,236,179,0.45) 0%, rgba(255,236,179,0) 60%), radial-gradient(50% 50% at 80% 90%, rgba(216,180,254,0.35) 0%, rgba(216,180,254,0) 60%)",
        }}
      />
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            "--dur": `${s.dur}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
      {particles.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            left: `${p.left}%`,
            bottom: `${p.bottom}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            "--pdur": `${p.dur}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};
